/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { getFeatureFlag } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import RecipientYourMessageTab from './RecipientYourMessageTab';
import RecipientWhatsInsideTab from './RecipientWhatsInsideTab';
import RecipientFlowerCareTab from './RecipientFlowerCareTab';
import RecipientPayItForwardTab from './RecipientPayItForwardTab';

const TabPanels = ({ cardIsleParams, ...props }) => {
   // Turns the whats inside tab - ON/OFF
   const isWhatsInsideTabEnabled = useSelector(getFeatureFlag('is-showing-whats-inside-tab'));
   const isFlowerCareTabEnabled = useSelector(getFeatureFlag('is-flower-care-tab-enabled'));
   const renderTabPanels = () => {
      const yourMessageTab = (
        <RecipientYourMessageTab
          key="yourMessageTab-0"
          reference={props.sectionRefs[0]}
          id={0}
          recipientVerifyData={props.recipientVerifyData}
          cardIsleParams={cardIsleParams}
        />
      );
    
      const whatsInsideTab = isWhatsInsideTabEnabled ? (
        <RecipientWhatsInsideTab
          key="whatsInsideTab-1"
          reference={props.sectionRefs[1]}
          id={1}
        />
      ) : null;
    
      const flowerCareTab = isFlowerCareTabEnabled && props.isProductBrand18F ? (
        <RecipientFlowerCareTab
          key={`flowerCareTab-${isWhatsInsideTabEnabled ? 2 : 1}`}
          reference={isWhatsInsideTabEnabled ? props.sectionRefs[2] : props.sectionRefs[1]}
          id={isWhatsInsideTabEnabled ? 2 : isFlowerCareTabEnabled ? 1 : null}
        />
      ) : null;
    
      const payItForwardTab = isWhatsInsideTabEnabled ? (
        <RecipientPayItForwardTab
          key={`payItForwardTab-${props.isProductBrand18F ? '3' : '2'}`}
          reference={props.isProductBrand18F ? props.sectionRefs[3] : props.sectionRefs[2]}
          id={props.isProductBrand18F ? 3 : 2}
          cardIsleParams={cardIsleParams}
        />
      ) : (
        <RecipientPayItForwardTab
          key={`payItForwardTab-${props.isProductBrand18F ? '2' : '1'}`}
          reference={props.isProductBrand18F ? props.sectionRefs[2] : props.sectionRefs[1]}
          id={isFlowerCareTabEnabled && props.isProductBrand18F ? 2 : 1}
          cardIsleParams={cardIsleParams}
        />
      );
      
      

      return [yourMessageTab, whatsInsideTab, flowerCareTab, payItForwardTab].filter(component => component !== null).map((component) => component);
    };
    
  return <React.Fragment>{renderTabPanels()}</React.Fragment>
}

export default TabPanels;
